export default __webpack_public_path__ + "static/media/Quiz_06.58f4ae66.png";